import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { IFiUserData } from '@fi-shared/fi-shared-services/fi-user-data.service';
import { ICreatedByItem } from '@fi-shared/models/models';

@Component({
    selector: 'fi-comment-button',
    template: `<ng-content></ng-content>`,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class FiCommentButtonComponent {
    @Input() comments: ICreatedByItem[];
    @Input() currentUser: IFiUserData;

    constructor() {}

    getCommentsCount() {
        if (this.comments) {
            const count = this.comments.reduce((prevCount, currItem) => currItem.Count + prevCount, 0);
            return count;
        }
    }

    isCurrentUserCommented() {
        if (!this.comments || !this.currentUser) return false;
        return !!this.comments.find((comment) => comment.CreatedByUserId === this.currentUser.UserId);
    }
}
